import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { formatarData, formatarValor } from "../components/formatarValores";
import ReactGA from "react-ga4";

function ListaCompras() {
  const [compra, setCompra] = useState([]);
  const [noCompras, setNoCompras] = useState(false); // Estado para lidar com a ausência de compras
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Minhas compras",
    });
  }, []);

  let idAtleta = localStorage.getItem("user");
  idAtleta = JSON.parse(idAtleta);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/compras/cliente/${
            idAtleta.id
          }`
        );

        if (response.status === 201 || response.data.length === 0) {
          setNoCompras(true);
        } else {
          const sortedData = response.data.sort(
            (a, b) => new Date(b.dataCompra) - new Date(a.dataCompra) // Ordenar da data mais nova para a mais velha
          );
          setCompra(sortedData);
        }
      } catch (error) {
        setError(true);
        console.error("Erro ao buscar compra:", error);
      }
    };

    fetchData();
  }, []);

  const detalheCompra = (id) => {
    localStorage.setItem("idCompra", id);
    navigate("/ar/pagamentos/novo");
  };

  return (
    <div className="py-8 max-w-4xl mx-auto mt-16">
      <div className="mx-auto">
        <h1 className="text-2xl font-semibold text-center mb-6">
          Minhas compras
        </h1>
        {error ? (
          <p className="text-center text-red-500">Erro ao buscar compras.</p>
        ) : noCompras ? (
          <p className="text-center">Você ainda não fez compras.</p>
        ) : (
          <table className="table ml-0">
            <thead>
              <tr>
                <th className="text-center">Data/Hora</th>
                <th className="text-center px-1 min-w-[20px] max-w-[20px]">
                  Qtd
                </th>
                <th className="text-center">Valor</th>
                <th className="text-center">Status</th>
                <th className="text-center">Detalhes</th>
              </tr>
            </thead>
            <tbody>
              {compra.map((compra, index) => (
                <tr key={compra._id} className="bg-base-100 hover:bg-base-300">
                  <td className="py-3 px-2 text-center">
                    {formatarData(compra.dataCompra)}
                  </td>
                  <td className="py-3 px-0 text-center min-w-[20px] max-w-[20px]">
                    {compra.quantity}
                  </td>
                  <td className="py-3 px-2 text-center">
                    R$ {formatarValor(compra.totalPrice)}
                  </td>
                  <td
                    className={`py-3 px-2 text-center ${
                      compra.status === "Pago"
                        ? "text-green-600"
                        : "text-orange-500"
                    }`}
                  >
                    {compra.status}
                  </td>
                  <td className="py-3 px-2">
                    <div className="flex justify-center gap-x-1">
                      <button
                        onClick={() => detalheCompra(compra._id)}
                        className={`${
                          compra.status === "Pago"
                            ? "bg-green-600  hover:bg-green-900"
                            : "bg-orange-500  hover:bg-orange-900"
                        } rounded-md text-white py-2 px-2 font-normal text-sm`}
                      >
                        Detalhes
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default ListaCompras;
